// Las reglas de impresión están en FinancesView.css
const PRINT_ROOT_ID = 'fin-print-root';

const clearPrint = () => {
  document.body.classList.remove('fin-printing');
  const root = document.getElementById(PRINT_ROOT_ID);
  if (root) root.remove();
};

// Imprime solo una copia del elemento, colgada directamente de <body> para que no la limite el layout de la app
export const printElement = (element: HTMLElement) => {
  clearPrint();
  const root = document.createElement('div');
  root.id = PRINT_ROOT_ID;
  root.appendChild(element.cloneNode(true));
  document.body.appendChild(root);
  document.body.classList.add('fin-printing');
  window.addEventListener('afterprint', clearPrint, { once: true });
  window.print();
};
